import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getRandomColor} from "../utils/GetRandomColor";

export default function IconText({icon, text, bgColor}) {
    const textStyles = {
        color: '#ffffff',
        padding: '2px',
        display: 'inline-flex',
        alignItems: 'center',
        gap: icon ? '6px' : '0px',
        textAlign: 'left',
        backgroundColor: bgColor ? getRandomColor() : 'transparent',
    };

    return (
        <span style={textStyles}>
            {icon && <FontAwesomeIcon icon={icon}/>}
            {text}
        </span>
    );
}